// extracted by mini-css-extract-plugin
export var root = "PlasmicHome-module--root--SMEIP";
export var box = "PlasmicHome-module--box--1qVOV";
export var homeHeader = "PlasmicHome-module--homeHeader--3VfLm";
export var container = "PlasmicHome-module--container--1WnN5";
export var listItem__gck4A = "PlasmicHome-module--listItem__gck4A--3LGel";
export var listItem__d35D = "PlasmicHome-module--listItem__d35D--_ltUv";
export var listItem__meWzn = "PlasmicHome-module--listItem__meWzn--28fpv";
export var footer = "PlasmicHome-module--footer--31UkF";